<template>
  <v-container
    v-if="AppType.isQRScanApp"
    fluid
  >
    <v-row
      v-if="AppQrData"
      dense
    >
      <v-col cols="12">
        <v-alert
          border="left"
          class="mb-0 pr-2 text-no-select"
          color="brand-primary"
          colored-border
          dense
          text
          type="info"
        >
          {{ sourceType }} <span class="font-weight-medium">{{ qrValue }}</span>

          <template #prepend>
            <v-icon
              class="mr-2"
              color="brand-primary"
              size="28"
            >
              {{ icon }}
            </v-icon>
          </template>

          <template
            v-if="AppConfig.Marketplace.CanChangeQrData || AppConfig.Marketplace.CanClearQrData || AppConfig.Marketplace.CanClearAppType"
            #append
          >
            <v-btn
              v-if="AppConfig.Marketplace.CanChangeQrData"
              class="ml-1 font-weight-bold"
              color="brand-primary"
              depressed
              small
              @click="showSelectQrItemDialog"
            >
              {{ $t('Common.Button.Change') }}
            </v-btn>

            <v-btn
              v-if="AppConfig.Marketplace.CanClearQrData || AppConfig.Marketplace.CanClearAppType"
              class="ml-1 px-0"
              color="grey darken-2"
              dark
              depressed
              small
              style="min-width: 28px"
              @click="clearSessionData"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-alert>
      </v-col>

      <v-col
        v-if="waiterServiceActive"
        cols="12"
      >
        <v-alert
          :style="chargeLoading ? '' : 'cursor: pointer;'"
          border="left"
          class="mb-0 pr-2 text-no-select"
          color="brand-primary"
          colored-border
          dense
          text
          type="info"
          @click="toggleWaiterService"
        >
          {{ getTranslatedField(waiterServiceCharge) }} {{ waiterServiceChargePrice | currency }}

          <template #prepend>
            <v-icon
              class="mr-2"
              color="brand-primary"
              size="28"
            >
              mdi-room-service
            </v-icon>
          </template>

          <template #append>
            <template v-if="!chargeLoading">
              <div class="align-center">
                <span
                  :class="[cartWaiterService ? 'brand-primary--text' : '']"
                  class="font-weight-bold hidden-xs-only mr-2"
                >
                  {{ cartWaiterService ? $t('Common.Button.Toggle.ActiveF') : $t('Common.Button.Toggle.InactiveF') }}
                </span>

                <v-icon
                  :color="cartWaiterService ? 'brand-primary' : ''"
                  size="28"
                >
                  {{ cartWaiterService ? 'mdi-checkbox-marked-circle-outline' : 'mdi-checkbox-blank-circle-outline' }}
                </v-icon>
              </div>
            </template>

            <v-progress-circular
              v-else
              color="brand-primary"
              indeterminate
              size="24"
              width="2"
            />
          </template>
        </v-alert>
      </v-col>
    </v-row>

    <v-row
      v-if="!AppQrData && AppConfig.Marketplace.SelectQrDataRequired"
      dense
    >
      <v-col cols="12">
        <v-btn
          :large="$vuetify.breakpoint.xsOnly"
          :x-large="$vuetify.breakpoint.smAndUp"
          block
          class="pl-2 pr-3"
          color="brand-primary"
          depressed
          @click="$bus.$emit('select-table:show-dialog')"
        >
          <span class="brand-text-title brand-green-dark--text">{{ $t('Common.SelectQrItemDialog.Subtitle') }}</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import QrCodeOrderDataMixin from '@/theme/default/components/common/QrCodeOrderData.js'

export default {
  name  : 'QrCodeOrderData',
  mixins: [QrCodeOrderDataMixin]
}
</script>

<style scoped src="@/theme/default/components/common/QrCodeOrderData.css"></style>

<style scoped>
</style>
